// ContactModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function ContactModal({ show, handleClose, handleSave, contact }) {
  const [formData, setFormData] = useState({
    Entidad: '',
    oficina: '',
    Correo: '',
    Numero: ''
  });

  useEffect(() => {
    if (contact) {
      setFormData(contact);
    } else {
      setFormData({
        Entidad: '',
        oficina: '',
        Correo: '',
        Numero: ''
      });
    }
  }, [contact]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSave(formData);
    handleClose();
  };

  

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{contact ? 'Editar Contacto' : 'Agregar Contacto'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Form.Group controlId="formEntidad">
            <Form.Label>Entidad</Form.Label>
            <Form.Control
              type="text"
              name="Entidad"
              value={formData.Entidad}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formOficina" className="mt-3">
            <Form.Label>Oficina</Form.Label>
            <Form.Control
              type="text"
              name="oficina"
              value={formData.oficina}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formCorreo" className="mt-3">
            <Form.Label>Correo Electronico</Form.Label>
            <Form.Control
              type="email"
              name="Correo"
              value={formData.Correo}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="formNumero" className="mt-3">
            <Form.Label>Numero de contacto</Form.Label>
            <Form.Control
              type="int"
              name="Numero"
              value={formData.Numero}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit">
            Guardar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ContactModal;
